<template>
    <nav>
        <router-link to="/registro">
            <div class="mydiv animate-bg py-2 bg-gradient-to-r from-indigo-600 to-light-blue-500 overflow-hidden">
                <div class="relative max-w-8xl mx-auto px-4 sm:px-6 lg:px-8"><svg fill="none" viewBox="0 0 848 513"
                class="sm:hidden absolute right-1/2 transform translate-x-[235px] translate-y-[-90px] w-[848px] h-[513px]">
                <path fill="#fff" fill-opacity="0.1"
                    d="M424 0C310.94 0 240.26 56.944 212 170.811c42.4-56.944 91.86-78.295 148.4-64.054 32.266 8.114 55.311 31.686 80.836 57.777 41.552 42.489 89.676 91.683 194.764 91.683 113.06 0 183.74-56.944 212-170.811-42.4 56.944-91.86 78.295-148.4 64.054-32.245-8.114-55.311-31.686-80.836-57.777C577.212 49.193 529.088 0 424 0zM212 256.217c-113.06 0-183.74 56.944-212 170.812 42.4-56.945 91.86-78.296 148.4-64.055 32.245 8.114 55.311 31.686 80.836 57.777 41.552 42.49 89.676 91.683 194.764 91.683 113.06 0 183.74-56.944 212-170.811-42.4 56.944-91.86 78.296-148.4 64.054-32.245-8.113-55.311-31.685-80.836-57.777-41.552-42.489-89.676-91.683-194.764-91.683z">
                </path>
                <path stroke="#fff" stroke-opacity="0.2"
                    d="M360.522 106.272l-.122.485.122-.485zm0 0c32.383 8.143 55.504 31.778 80.966 57.805l.105.107-.318.312.318-.311c20.78 21.248 43.155 44.121 73.45 61.692 30.282 17.564 68.498 29.84 120.957 29.84 56.444 0 102.26-14.213 137.486-42.595 34.73-27.982 59.217-69.776 73.424-125.433-20.822 27.449-43.355 46.428-67.609 56.898-24.842 10.723-51.456 12.503-79.823 5.358-32.389-8.15-55.544-31.819-81.032-57.872l-.039-.04.357-.35-.357.35c-20.78-21.25-43.155-44.122-73.449-61.693C514.675 12.777 476.459.5 424 .5c-56.444 0-102.26 14.213-137.486 42.595-34.73 27.982-59.217 69.776-73.424 125.434 20.822-27.45 43.355-46.429 67.609-56.898 24.842-10.723 51.456-12.504 79.823-5.359zm45.885 241.978l.286-.28-.286.28.039.04c25.488 26.053 48.643 49.722 81.032 57.872 28.367 7.145 54.981 5.365 79.823-5.358 24.254-10.47 46.787-29.449 67.609-56.898-14.207 55.657-38.694 97.452-73.424 125.433-35.226 28.382-81.042 42.595-137.486 42.595-52.459 0-90.675-12.276-120.957-29.84-30.295-17.571-52.67-40.443-73.45-61.692l-.337.329.337-.329-.039-.041c-25.488-26.053-48.643-49.722-81.032-57.872-28.367-7.145-54.98-5.364-79.823 5.359-24.254 10.469-46.787 29.448-67.609 56.898 14.207-55.657 38.694-97.452 73.424-125.434C109.74 270.93 155.556 256.717 212 256.717c52.459 0 90.675 12.277 120.957 29.841 30.295 17.57 52.67 40.443 73.45 61.692z">
                </path>
                <path stroke="url(#mark-mobile__paint0_linear)" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5" d="M647.5 120c-6-4.5-13.5-12.5-13.5-12.5"></path>
                <path stroke="url(#mark-mobile__paint1_linear)" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5" d="M212 256c11.118 0 21.598.551 31.5 1.586"></path>
                <path stroke="url(#mark-mobile__paint2_linear)" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5" d="M632.5 255.793c-11.118 0-21.598-.551-31.5-1.586"></path>
                <defs>
                    <linearGradient id="mark-mobile__paint0_linear" x1="648.5" x2="636.5" y1="119.803" y2="108"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#fff"></stop>
                        <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
                    </linearGradient>
                    <linearGradient id="mark-mobile__paint1_linear" x1="220.5" x2="245" y1="256.783" y2="257.783"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#fff"></stop>
                        <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
                    </linearGradient>
                    <linearGradient id="mark-mobile__paint2_linear" x1="624" x2="599.5" y1="255.01" y2="254.01"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#fff"></stop>
                        <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
                    </linearGradient>
                </defs>
                </svg><svg fill="none" viewBox="0 0 848 513"
                    class="hidden sm:block absolute right-1/2 transform translate-x-[-150px] translate-y-[-250px] w-[848px] h-[513px]">
                    <path fill="#fff" fill-opacity="0.1"
                        d="M424 0C310.94 0 240.26 56.944 212 170.811c42.4-56.944 91.86-78.295 148.4-64.054 32.266 8.114 55.311 31.686 80.836 57.777 41.552 42.489 89.676 91.683 194.764 91.683 113.06 0 183.74-56.944 212-170.811-42.4 56.944-91.86 78.295-148.4 64.054-32.245-8.114-55.311-31.686-80.836-57.777C577.212 49.193 529.088 0 424 0zM212 256.217c-113.06 0-183.74 56.944-212 170.812 42.4-56.945 91.86-78.296 148.4-64.055 32.245 8.114 55.311 31.686 80.836 57.777 41.552 42.49 89.676 91.683 194.764 91.683 113.06 0 183.74-56.944 212-170.811-42.4 56.944-91.86 78.296-148.4 64.054-32.245-8.113-55.311-31.685-80.836-57.777-41.552-42.489-89.676-91.683-194.764-91.683z">
                    </path>
                    <path stroke="#fff" stroke-opacity="0.2"
                        d="M360.522 106.272l-.122.485.122-.485zm0 0c32.383 8.143 55.504 31.778 80.966 57.805l.105.107-.318.312.318-.311c20.78 21.248 43.155 44.121 73.45 61.692 30.282 17.564 68.498 29.84 120.957 29.84 56.444 0 102.26-14.213 137.486-42.595 34.73-27.982 59.217-69.776 73.424-125.433-20.822 27.449-43.355 46.428-67.609 56.898-24.842 10.723-51.456 12.503-79.823 5.358-32.389-8.15-55.544-31.819-81.032-57.872l-.039-.04.357-.35-.357.35c-20.78-21.25-43.155-44.122-73.449-61.693C514.675 12.777 476.459.5 424 .5c-56.444 0-102.26 14.213-137.486 42.595-34.73 27.982-59.217 69.776-73.424 125.434 20.822-27.45 43.355-46.429 67.609-56.898 24.842-10.723 51.456-12.504 79.823-5.359zm45.885 241.978l.286-.28-.286.28.039.04c25.488 26.053 48.643 49.722 81.032 57.872 28.367 7.145 54.981 5.365 79.823-5.358 24.254-10.47 46.787-29.449 67.609-56.898-14.207 55.657-38.694 97.452-73.424 125.433-35.226 28.382-81.042 42.595-137.486 42.595-52.459 0-90.675-12.276-120.957-29.84-30.295-17.571-52.67-40.443-73.45-61.692l-.337.329.337-.329-.039-.041c-25.488-26.053-48.643-49.722-81.032-57.872-28.367-7.145-54.98-5.364-79.823 5.359-24.254 10.469-46.787 29.448-67.609 56.898 14.207-55.657 38.694-97.452 73.424-125.434C109.74 270.93 155.556 256.717 212 256.717c52.459 0 90.675 12.277 120.957 29.841 30.295 17.57 52.67 40.443 73.45 61.692z">
                    </path>
                    <path stroke="url(#mark-left__paint0_linear)" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5" d="M212 256c11.118 0 21.598.551 31.5 1.586"></path>
                    <path stroke="url(#mark-left__paint1_linear)" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5" d="M632.5 255.793c-11.118 0-21.598-.551-31.5-1.586"></path>
                    <defs>
                        <linearGradient id="mark-left__paint0_linear" x1="220.5" x2="245" y1="256.783" y2="257.783"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#fff"></stop>
                            <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
                        </linearGradient>
                        <linearGradient id="mark-left__paint1_linear" x1="624" x2="599.5" y1="255.01" y2="254.01"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#fff"></stop>
                            <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
                        </linearGradient>
                    </defs>
                </svg><svg fill="none" viewBox="0 0 848 513"
                    class="hidden sm:block absolute left-1/2 transform translate-x-[330px] translate-y-[-357px] w-[848px] h-[513px]">
                    <path fill="#fff" fill-opacity="0.1"
                        d="M424 0C310.94 0 240.26 56.944 212 170.811c42.4-56.944 91.86-78.295 148.4-64.054 32.266 8.114 55.311 31.686 80.836 57.777 41.552 42.489 89.676 91.683 194.764 91.683 113.06 0 183.74-56.944 212-170.811-42.4 56.944-91.86 78.295-148.4 64.054-32.245-8.114-55.311-31.686-80.836-57.777C577.212 49.193 529.088 0 424 0zM212 256.217c-113.06 0-183.74 56.944-212 170.812 42.4-56.945 91.86-78.296 148.4-64.055 32.245 8.114 55.311 31.686 80.836 57.777 41.552 42.49 89.676 91.683 194.764 91.683 113.06 0 183.74-56.944 212-170.811-42.4 56.944-91.86 78.296-148.4 64.054-32.245-8.113-55.311-31.685-80.836-57.777-41.552-42.489-89.676-91.683-194.764-91.683z">
                    </path>
                    <path stroke="#fff" stroke-opacity="0.2"
                        d="M360.522 106.272l-.122.485.122-.485zm0 0c32.383 8.143 55.504 31.778 80.966 57.805l.105.107-.318.312.318-.311c20.78 21.248 43.155 44.121 73.45 61.692 30.282 17.564 68.498 29.84 120.957 29.84 56.444 0 102.26-14.213 137.486-42.595 34.73-27.982 59.217-69.776 73.424-125.433-20.822 27.449-43.355 46.428-67.609 56.898-24.842 10.723-51.456 12.503-79.823 5.358-32.389-8.15-55.544-31.819-81.032-57.872l-.039-.04.357-.35-.357.35c-20.78-21.25-43.155-44.122-73.449-61.693C514.675 12.777 476.459.5 424 .5c-56.444 0-102.26 14.213-137.486 42.595-34.73 27.982-59.217 69.776-73.424 125.434 20.822-27.45 43.355-46.429 67.609-56.898 24.842-10.723 51.456-12.504 79.823-5.359zm45.885 241.978l.286-.28-.286.28.039.04c25.488 26.053 48.643 49.722 81.032 57.872 28.367 7.145 54.981 5.365 79.823-5.358 24.254-10.47 46.787-29.449 67.609-56.898-14.207 55.657-38.694 97.452-73.424 125.433-35.226 28.382-81.042 42.595-137.486 42.595-52.459 0-90.675-12.276-120.957-29.84-30.295-17.571-52.67-40.443-73.45-61.692l-.337.329.337-.329-.039-.041c-25.488-26.053-48.643-49.722-81.032-57.872-28.367-7.145-54.98-5.364-79.823 5.359-24.254 10.469-46.787 29.448-67.609 56.898 14.207-55.657 38.694-97.452 73.424-125.434C109.74 270.93 155.556 256.717 212 256.717c52.459 0 90.675 12.277 120.957 29.841 30.295 17.57 52.67 40.443 73.45 61.692z">
                    </path>
                    <path stroke="url(#mark-right__paint0_linear)" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5" d="M148.4 362.974c-20.178-5.082-39.454-5.631-57.83-1.648"></path>
                    <defs>
                        <linearGradient id="mark-right__paint0_linear" x1="106.175" x2="151.193" y1="360.811" y2="362.062"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#fff"></stop>
                            <stop offset="1" stop-color="#fff" stop-opacity="0"></stop>
                        </linearGradient>
                    </defs>
                </svg>
                <div class="relative flex justify-center items-center">
                    <div class="text-base font-medium text-white">Register now and get a 
                        <span class="bg-gradient-to-r from-yellow-200 to-yellow-500   bg-clip-text text-transparent"> free</span>
                        year
                        </div>
                    <span aria-hidden="true" class="hidden sm:block mx-6 h-6 w-px bg-white bg-opacity-20"></span>
                    <div class="ml-6 sm:ml-0"><a
                            class="whitespace-nowrap inline-flex rounded-md bg-white py-2 px-3 text-xs font-medium uppercase text-blue-500 hover:bg-opacity-90"
                            href="/docs/just-in-time-mode">Sign In →</a></div>
                </div>
                </div>
            </div>
        </router-link>
        
        <div class="relative bg-gradient-to-r from-indigo-900 to-gray-900">
            <div class="flex justify-between items-center max-w-8xl mx-auto py-1 px-2 md:px-6 md:justify-start">
                
                <div class="flex justify-left lg:w-0 lg:flex-1">
                    <router-link to="/">
                        <span class="sr-only">Asakaa AI Project Management</span>
                        <img class="hidden lg:block h-10 w-auto" :src="urlsf + 'images/asakaa_logo_artificial_inteligence.svg'" alt="Asakaa AI Project Management" />
                        <img class="block lg:hidden h-10 w-auto" :src="urlsf + 'images/asakaa_logo_artificial_inteligence.svg'" alt="Asakaa AI Project Management" />
                    </router-link>
                </div>

                <div class="-mr-2 -my-2 md:hidden" @click="changeSolutionsClassMobile">
                    <button type="button" class="bg-white rounded p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" aria-expanded="false">
                        <span class="sr-only">Open menu</span>
                        <!-- Heroicon name: outline/menu -->
                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>

                <nav class="hidden md:flex space-x-10">
                    <div class="relative">
                        
                        <div class="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
                             v-bind:class="{ invisible: solutionsState }">
                            <div class="rounded shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                                <div class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                                    <a href="#"
                                       class="-m-3 p-3 flex items-start rounded hover:bg-gray-50">
                                        <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                                            <!-- Heroicon name: outline/inbox -->
                                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                            </svg>
                                        </div>
                                        <div class="ml-4">
                                            <p class="text-base font-medium text-gray-900">Inbox</p>
                                            <p class="mt-1 text-sm text-gray-500">
                                                Get a better understanding of where your traffic is
                                                coming from.
                                            </p>
                                        </div>
                                    </a>

                                    <a href="#"
                                       class="-m-3 p-3 flex items-start rounded hover:bg-gray-50">
                                        <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                                            <!-- Heroicon name: outline/annotation -->
                                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                                            </svg>
                                        </div>
                                        <div class="ml-4">
                                            <p class="text-base font-medium text-gray-900">
                                                Messaging
                                            </p>
                                            <p class="mt-1 text-sm text-gray-500">
                                                Speak directly to your customers in a more meaningful
                                                way.
                                            </p>
                                        </div>
                                    </a>

                                    <a href="#"
                                       class="-m-3 p-3 flex items-start rounded hover:bg-gray-50">
                                        <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                                            <!-- Heroicon name: outline/chat-alt-2 -->
                                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
                                            </svg>
                                        </div>
                                        <div class="ml-4">
                                            <p class="text-base font-medium text-gray-900">
                                                Live Chat
                                            </p>
                                            <p class="mt-1 text-sm text-gray-500">
                                                Your customers&#039; data will be safe and secure.
                                            </p>
                                        </div>
                                    </a>

                                    <a href="#"
                                       class="-m-3 p-3 flex items-start rounded hover:bg-gray-50">
                                        <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                                            <!-- Heroicon name: outline/question-mark-circle -->
                                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <div class="ml-4">
                                            <p class="text-base font-medium text-gray-900">
                                                Knowledge Base
                                            </p>
                                            <p class="mt-1 text-sm text-gray-500">
                                                Connect with third-party tools that you&#039;re already
                                                using.
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <router-link to="/precios" class="text-md font-semibold text-gray-300 hover:text-white">
                        Pricing
                    </router-link>

                    <router-link to="/contacto" class="text-md font-semibold text-gray-300 hover:text-white">
                        Contact
                    </router-link>

                </nav>
                <div class="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                    <router-link to="/entrar" class="whitespace-nowrap font-semibold text-gray-300 hover:text-white">
                        Login
                    </router-link>
                    <router-link to="/registro" class="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm text-base font-semibold text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700">
                        Sign up
                    </router-link>
                </div>
            </div>

            <!--
              Mobile menu, show/hide based on mobile menu state.

              Entering: "duration-200 ease-out"
                From: "opacity-0 scale-95"
                To: "opacity-100 scale-100"
              Leaving: "duration-100 ease-in"
                From: "opacity-100 scale-100"
                To: "opacity-0 scale-95"
            -->
            <div v-bind:class="{ invisible: solutionsStateMobile }"
                 class="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
                <div class="rounded shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                    <div class="pt-5 pb-6 px-5">
                        <div class="flex items-center justify-between">
                            <div>
                                <img class="block lg:hidden h-8 w-auto" :src="urlsf + 'images/asakaa_logo.svg'" alt="Asakaa Project Management with IA" />
                            </div>
                            <div class="-mr-2" @click="hideSolutionsBannerMobile" @blur="hideSolutionsBannerMobile">
                                <button type="button"
                                        class="bg-white rounded p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none">
                                    <span class="sr-only">Close menu</span>
                                    <!-- Heroicon name: outline/x -->
                                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="mt-6">
                            <nav class="grid grid-cols-1 gap-7">

                                <router-link to="/precios" class="-m-3 p-3 flex items-center rounded hover:bg-gray-50">
                                    <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
                                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                        </svg>
                                    </div>
                                    <div class="ml-4 text-base font-medium text-gray-900">
                                        Pricing
                                    </div>
                                </router-link>

                                <router-link to="/contacto" class="-m-3 p-3 flex items-center rounded hover:bg-gray-50">
                                    <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
                                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div class="ml-4 text-base font-medium text-gray-900">
                                        Contact
                                    </div>
                                </router-link>

                            </nav>
                        </div>
                    </div>
                    <div class="py-6 px-5">
                        
                        <div class="mt-6">
                            
                            <router-link to="/registro" class="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded shadow-md text-base font-medium text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700">
                                Sign up
                            </router-link>

                            <p class="mt-6 text-center text-base font-medium text-gray-500">
                                
                                <router-link to="/entrar" class="text-indigo-600 text-base font-semibold">
                                    Login
                                </router-link>
                            </p>
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </nav>
</template>

<script>

    import Store from '@/store/index'
    
    export default {

        name:'Barra-Inicio',
        
        data: function () {
            return {
                solutionsState: true,
                solutionsStateMobile: true,
            };
        },

        computed: {

            ruta(){ return this.$router.currentRoute.path },
            urlsf(){ return Store.state.urlsf },

        },

        methods: {
            changeSolutionsClass(){ this.solutionsState = !this.solutionsState },

            hideSolutionsBanner(){ this.solutionsState = true },

            changeSolutionsClassMobile(){ this.solutionsStateMobile = !this.solutionsStateMobile },

            hideSolutionsBannerMobile(){ this.solutionsStateMobile = true },
        },
    }
</script>
<style scoped>
      /* animation of border for free year */

.mydiv {
	position: relative;
}

.animate-bg:before, .animate-bg:after {
	content: '';
	position: absolute;
	left: -4px;
	top: -4px;
	background: linear-gradient(120deg,cornflowerblue, purple 50%, cornflowerblue);
	background-size: 300%;
	width: calc(100% + 16px);
	height: calc(100% + 16px);
	z-index: -1;
	animation: BGgradient 7s ease infinite; 
}

@keyframes BGgradient {
	0% {
		background-position: 0% 200%;
	}
	50% {
		background-position: 200% 0%;
	}
	100% {
		background-position: 0% 330%;
	}
}

.animate-bg:after {
	filter: brightness(1.4);
}


</style>




